import { t } from "i18next";

export const getNumberFromOCSFSeverityName = (t, value: number) => {
  switch (value) {
    case t("SEVERITY.INFORMATIVE"):
      // Informational message. No action required.
      return 1;
    case t("SEVERITY.LOW"):
      // The user decides if action is needed.
      return 2;
    case t("SEVERITY.MEDIUM"):
      // Action is required but the situation is not serious at this time.
      return 3;
    case t("SEVERITY.HIGH"):
      // Action is required immediately.
      return 4;
    case t("SEVERITY.CRITICAL"):
      // Action is required immediately and the scope is broad.
      return 5;
    case t("SEVERITY.FATAL"):
      // An error occurred but it is too late to take remedial action.
      return 6;
    default:
      // The event/finding severity is not mapped. See the severity attribute, which contains a data source specific value.
      // Severity is undefined
      return 0;
  }
}

export function getFilterCount(searchTerm: string, filtersObj: any) {
    const filterTerms = Object.values(filtersObj) as string[];
    let filterCount = 0;
    if (Object.keys(filterTerms).length === 0) {
      filterCount = searchTerm === "" ? 0 : 1
    } else {
      filterCount = searchTerm === "" ? filterTerms.join(',').split(',').length : filterTerms.join(',').split(',').length + 1
    }
    return filterCount
}

export function getFilters(filter, params) {
    if ("categories" in filter) {
        (filter["categories"] ?? []).map((category) => {
          if (category.children.length > 0) {
            let values;
            category.children.map((child) => {
              if (values) {
                  if ("apiValue" in child) {
                    values = values + "," + child.apiValue
                  } else {
                    values = values + "," + child.name
                  }
              } else {
                if ("apiValue" in child) {
                  values = child.apiValue
                } else {
                  values = child.name
                }
              }
            })
  
            params.filters[`filter[${category.label}]`] = values;
          }
        });
        
    } else if ("selectedSeverity" in filter) {
        // Translate the OCSF name back to a number for the db to match 
        const selectedSeverityNum = getNumberFromOCSFSeverityName(t, filter["selectedSeverity"]).toString()

        if ("filter[severity]" in params.filters) {
          // Asserting the type of params.filters["filter[severity]"] as string
          const severityFilter = params.filters["filter[severity]"] as string;

          // If the list does not already include the filter
          if (!params.filters["filter[severity]"].split(",").includes(selectedSeverityNum)) {
            const newList = severityFilter.split(",");
            newList.push(selectedSeverityNum); // Push the selectedSeverityNum into the array
            params.filters["filter[severity]"] = newList.join(",");
          }
        } else {
          params.filters["filter[severity]"] = selectedSeverityNum
        }

    } else if ("start" in filter && "end" in filter) {
        // A cleared date will set the value to "", check for this
        if (filter["start"] === "" || filter["end"] === "") {
            delete params.filters["startDate"]
            delete params.filters["endDate"]
        } else {
            params.filters["startDate"] = filter["start"]
            params.filters["endDate"] = filter["end"]
        }
    }

    if ("framework" in filter) {
      params.filters["filter[framework]"] = filter.framework;
    }

    if ("rule" in filter) {
      params.filters["filter[rule]"] = filter.rule;
    }

    return(params.filters)
}